export default __webpack_public_path__ + "assets/uv-index-1.204a72e2.svg";